import { clearToken } from 'features/auth/tokensSlice';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { persistor, store } from '../../redux/store';

const useLogoutFromGestao = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkUrlParamsLogout = async () => {
      const urlParams = new URLSearchParams(location.search);

      if (urlParams.get('logout') === 'true') {
        setIsLoading(true);
        try {
          // Limpa o Redux e o Redux Persist
          await persistor.purge();
          store.dispatch(clearToken());

          // Aguarda o próximo ciclo do event loop para garantir limpeza antes de redirecionar
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_GESTAO_BASE_URL}/logon?logout=true`;
          }, 100);
        } finally {
          setIsLoading(false);
        }
      }
    };

    checkUrlParamsLogout();
  }, [location]);

  return { isLoading };
};

export default useLogoutFromGestao;
